import sdk from '@/sdk';

export const getIsAuto = () => {
    const isAuto = sdk.as.user?.settings?.newSettings?.intelligent?.openAIAgentAuto || false;
    return isAuto;
};
